import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';
import { truncate } from 'lodash/string';

class DonationsSliderCard extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let path = this.props.path;
    let browser = this.props.browser;
    let fullImgPath = path + this.props.imgUrl;
    return(
      <div className="festivalTickets-donationSliderImg">
        <img src={fullImgPath} />
      </div>
    );
  }
};

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps
)(DonationsSliderCard);



// WEBPACK FOOTER //
// ./src/components/festival/donationsSlider/DonationsSliderCard.jsx